export default function () {
    return function (input) {
        input = input[0].toUpperCase() + input.substr(1).toLowerCase();
        if (input.charCodeAt(input.length - 1) === 0) {
            input = input.substr(0, input.length - 1) + '.';
        }
        return input;
    }
};